import React, { Component } from "react";
import { Button, withStyles } from "@material-ui/core";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { logout } from "../../actions/userActions";
const styles = theme => ({
    root: {
        color: "#fff",
        minWidth: "128px"
    }
})
class LogOutButton extends Component {
    render() {
        const { classes, logout, history } = this.props;
        return (
            <Button size="large"
                classes={classes}
                style={this.props.style}
                onClick={() => { logout().then(() => history.push('/')) }}
            >
                Log out
            </Button>
        );
    }

}

function mapStateToProps( state, ownProps ) {
    return {

    }
}

function mapDispatchToProps( dispatch, ownProps ) {
    return {
        logout: () => dispatch( logout() )
    }
}

LogOutButton = connect(
    mapStateToProps,
    mapDispatchToProps
)( LogOutButton );

export default withRouter(withStyles( styles )( LogOutButton ));
